import { render, staticRenderFns } from "./ImpactaMasSupplier.vue?vue&type=template&id=6f3a5135&scoped=true&"
import script from "./ImpactaMasSupplier.vue?vue&type=script&lang=js&"
export * from "./ImpactaMasSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a5135",
  null
  
)

export default component.exports